import {JobEventTypeEnum} from "./event/JobEvent";

export default class JobAction {

	/**
	 * Convert string to JobAction.
	 * @param {string} string
	 * @return {JobAction}
	 */
	public static fromString(string: string): JobAction {
		return new JobAction(string)
	}

	/**
	 * Get label
	 * @return {string}
	 */
	public getActionLabel() {
		switch (this.id) {
			case JobEventTypeEnum.Created:
				return JobActionLabelEnum.Created;
			case JobEventTypeEnum.Updated:
				return JobActionLabelEnum.Updated;
			case JobEventTypeEnum.BdpAssigneeChanged:
				return JobActionLabelEnum.BdpAssigneeChanged;
			case JobEventTypeEnum.AgentAssigneeChanged:
				return JobActionLabelEnum.AgentAssigneeChanged;
			case JobEventTypeEnum.StatusChanged:
				return JobActionLabelEnum.StatusChanged;
			case JobEventTypeEnum.NoteCreated:
				return JobActionLabelEnum.NoteCreated;
			case JobEventTypeEnum.JobSmsSent:
				return JobActionLabelEnum.JobSmsSent;
			case JobEventTypeEnum.JobEmailSent:
				return JobActionLabelEnum.JobEmailSent;
			case JobEventTypeEnum.MarkedAsPaid:
				return JobActionLabelEnum.MarkedAsPaid;
			default:
				return this.id
		}
	}

	/**
	 * Job action object.
	 * @param {string} id Job action id
	 */
	constructor(public readonly id: string) {}
}

export enum JobActionLabelEnum {
	Created = "Created",
	Updated = "Edited",
	StatusChanged = "Status",
	NoteCreated = "Note",
	BdpAssigneeChanged = "BDP Changed",
	AgentAssigneeChanged = "Agent Changed",
	JobSmsSent = "Sms Sent",
	JobEmailSent = "Email Sent",
	MarkedAsPaid = "Marked as paid"
}